import { z } from 'zod';
/**
 * Die zwei Aufzählungen des Kundenportals, die sowohl am Beleg
 * (`documents.ts`) als auch im Portal-Vertrag selbst (`portal.ts`) gebraucht
 * werden — Befund H8 des Reviews vom 2026-09-17 zu `KP-oberflaeche`.
 *
 * **Warum ein eigenes Blattmodul und nicht einer der beiden Verträge selbst.**
 * `portal.ts` importiert `unitPriceAmount` aus `documents.ts`; ein Import in
 * der Gegenrichtung wäre ein Modulkreis, und ein Kreis über zwei Moduln,
 * deren Wert beim Laden entsteht (`z.enum(…)` ist ein Aufruf, keine
 * Deklaration), endet in einer uninitialisierten Bindung statt in einem
 * Schema. Vor diesem Befund standen deshalb zwei wortgleiche Aufzählungen in
 * beiden Dateien, gehalten nur durch eine Testprobe
 * (`apps/web/test/schemas.test.ts`, „haelt die doppelt gefuehrten
 * Portal-Aufzaehlungen gegeneinander"). Dieses Blattmodul importiert
 * **ausschliesslich `zod`** — keine Abhängigkeit zu `documents.ts` oder
 * `portal.ts` — und kann deshalb von beiden gefahrlos importiert werden; die
 * Testprobe entfällt, weil beide Seiten jetzt dieselbe Objektreferenz
 * benutzen und nicht mehr auseinanderlaufen können.
 *
 * **Namen hier `kundenportal…`, öffentlich weiterhin `portalKundenereignisArt`/
 * `dokumentPortalEreignisArt` usw.** `portal.ts` führt bereits einen
 * eigenen, deutlich breiteren `portalEreignisArtSchema` (die volle
 * Verlaufsart eines Belegs — `zahlung`, `mahnung`, `storniert`, … — nicht die
 * zwei Ereignisse, die das Portal selbst melden darf); ein gleichnamiger
 * Import aus diesem Blattmodul würde dort mit der lokalen Deklaration
 * kollidieren. Beide öffentlichen Namen aus `portal.ts`
 * (`portalKundenereignisArtSchema`, `portalEntscheidungArtSchema`) bleiben
 * als Re-Export erhalten, damit `KP-beleg`/`KP-angebot`/`KP-kunde` beim
 * Stapeln nichts umbenennen müssen.
 */
export const kundenportalEreignisArtSchema = z.enum(['geoeffnet', 'pdf_geladen']);
export const kundenportalEntscheidungArtSchema = z.enum(['angenommen', 'abgelehnt']);
//# sourceMappingURL=portal-arten.js.map